import React from 'react';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import classes from './Pattern.module.css';
import {VisibilityOff} from "@material-ui/icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

const Pattern = ({selected, cardBodyStyle, cardBodyText, name, clicked, chosenPattern, titleCSS = '', hiddenContent, mergedStatus = 0}) => {

    // console.log('SELECTED: ',props.selected);
    let header_icon = '';
    if (selected === ' new-pattern-list') {
        header_icon = (
            <div className="add-circle"><AddCircleOutlineIcon style={{color: 'green'}} fontSize={"large"}/></div>);
    }

    const hiddenContentStyle = {border: "3px solid #bf8888", height: 150, boxShadow: chosenPattern ? '0px 0px 4px 2px #bf8888' : 'none'}
    const defaultStyle = {height: 150, boxShadow: chosenPattern ? '0px 0px 4px 2px #52abcc' : 'none'};

    const grayColor = '#a1a1a1'

    const mergeStyles = {
        border: `3px solid ${+mergedStatus === 1 ? 'orange' : grayColor}`,
        height: 150,
        boxShadow: chosenPattern ? `0px 0px 4px 2px ${+mergedStatus === 1 ? 'orange' : grayColor}` : 'none'
    }

    let outerStyles = defaultStyle;
    if (hiddenContent) {
        outerStyles = hiddenContentStyle;
    } else if (mergedStatus !== 0) {
        outerStyles = mergeStyles
    }


    return (
        <div className={"card "+classes.Pattern + selected} onClick={clicked} style={outerStyles}>
            <h4 className={"card-header " + classes.truncate + ' ' + titleCSS}
                style={hiddenContent ? {borderBottom: "1px solid #bf8888"} : {}}>{name} {header_icon} {hiddenContent
                ? <React.Fragment>
                    {/*This should turn into the new hovericon*/}
                    <OverlayTrigger
                        trigger={["hover", "focus"]}
                        delay={{show: 500}}
                        rootClose
                        rootCloseEvent="click"
                        placement='bottom'
                        overlay={
                            <Popover id='hidden-content-info'>
                                <Popover.Title as="h3">Hidden Content</Popover.Title>
                                <Popover.Content className="hidden-content">
                                    {"This pattern may be hidden for a variety of reasons. Select the pattern and hover over this " +
                                        "icon in its header below to view the details."}
                                </Popover.Content>
                            </Popover>
                        }
                    >
                        <VisibilityOff style={{color: "#bf8888", float: "right"}}/>
                    </OverlayTrigger>
                    {/*Is there a reason the one below is here? I merged it so it says I added it, but I don't think I was the one who actually put it there did.*/}
                    <VisibilityOff style={{color: "rgba(0,0,0,0)", float: "left"}}/>
                </React.Fragment>
                : ''}
            </h4>
            <div className={"card-body " + classes.truncate}>
                <div className={cardBodyStyle + ' ' + classes.truncate}>{cardBodyText}</div>
            </div>
        </div>
    );
};

export default Pattern;